import { CPPFunction, CPPHelper, CPPVisibility, CPPWritableObject } from 'aclovis';
import { ChunkWriter } from './ChunkWriter';
export default class CleanupChunk extends ChunkWriter {
    constructor(pluginClass, pluginDefinition) {
        super();
        this.pluginDefinition = pluginDefinition;
        this.fxn = new CPPFunction('void', 'Cleanup');
        this.fxn.setVirtual(true);
        this.fxn.setParentClass(pluginClass, CPPVisibility.Public);
    }
    process() {
        let fxnBody = [new CPPWritableObject('Flush();')];
        this.buildSlashCommandRemoval(fxnBody);
        this.buildMapObjectRemoval(fxnBody);
        this.buildBZDBSettingsRemoval(fxnBody);
        this.buildPollTypeRemoval(fxnBody);
        this.fxn.implementFunction(fxnBody);
    }
    buildSlashCommandRemoval(body) {
        this.unregisterFunctionRepeater('slashCommands', 'bz_removeCustomSlashCommand', (object) => [`"${object.name}"`], body);
    }
    buildMapObjectRemoval(body) {
        this.unregisterFunctionRepeater('mapObjects', 'bz_removeCustomMapObject', (object) => [`"${object.name.toUpperCase()}"`], body);
    }
    buildBZDBSettingsRemoval(body) {
        this.unregisterFunctionRepeater('bzdbSettings', 'bz_removeCustomBZDBVariable', (object) => [`"${object.name}"`], body);
    }
    buildPollTypeRemoval(body) {
        this.unregisterFunctionRepeater('pollTypes', 'bz_removeCustomPollType', (object) => [`"${object.name}"`], body);
    }
    unregisterFunctionRepeater(namespace, functionCall, functionParams, body) {
        const objects = this.pluginDefinition[namespace];
        if (Object.keys(objects).length === 0) {
            return;
        }
        body.push(CPPHelper.createEmptyLine());
        for (const name in objects) {
            const object = objects[name];
            body.push(CPPHelper.createFunctionCall(functionCall, functionParams(object)));
        }
    }
}
